import React from 'react';
import PropTypes from 'prop-types';

import { Flex, TabButton } from '@sopranodesign/pulse-components';
import { AnimateSharedLayout } from '@sopranodesign/framer-motion';

const ZendeskSettingsTabs = ({
  section,
  onChange,
  sections
}) => {
  if (sections.length === 0) {
    return null;
  }

  return (
    <Flex mb between center>
      <Flex>
        <AnimateSharedLayout>
          {sections.map(item => (
            <TabButton
              key={item.key}
              active={section === item.key}
              onClick={() => onChange(item.key)}
            >
              {item.label}
            </TabButton>
          ))}
        </AnimateSharedLayout>
      </Flex>
    </Flex>
  );
};

ZendeskSettingsTabs.propTypes = {
  section: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sections: PropTypes.array.isRequired,
};

export default ZendeskSettingsTabs;